/* @flow */
import React from 'react';
import { ListItem } from 'material-ui/List';
import ActionInfo from 'material-ui/svg-icons/action/info';
import Avatar from 'material-ui/Avatar';

import DateTime from '../../../../components/DateTime';
import Duration from '../../../../components/Duration';

type Props = {
  node: any,
};

const TutorJobHistory = ({ node }: Props) => {
  const { acceptedJobOffer } = node;
  const { sessions, jobRequest } = acceptedJobOffer;
  const { grade, subject, student } = jobRequest;
  const { firstname, lastname, profilePictureThumbnailUri } = student;

  return (
    <ListItem
      leftAvatar={<Avatar src={profilePictureThumbnailUri} />}
      rightIcon={<ActionInfo />}
      primaryText={
        <div>
          {sessions.map(({ timeSlot }) => (
            <span key={timeSlot.id}>
              <Duration {...timeSlot.duration} />
              {` of ${subject.name} (${grade.name}) `}
              <DateTime value={timeSlot.startDate} />
            </span>
          ))}
        </div>
      }
      secondaryText={`${firstname} ${lastname}`}
    />
  );
};

export default TutorJobHistory;



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/components/job/TutorJobHistory.js